if (!customElements.get('product-vto')) {
  customElements.define('product-vto', class ProductVTO extends ModalDialog {
    constructor() {
      super();

      this.qrCodeContent = this.querySelector('.vto-qrcode-wrapper');
      this.vtoContent = this.querySelector('.vto-mobile-wrapper');
      this.loader = this.querySelector('.loading-overlay');
      this.swatches = this.querySelector('.YMK-swatchs');
      this.addToCart = this.querySelector('add-to-cart');

      this.VirtualTryOnSdk = new VirtualTryOnSdk();

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get('open-vto')) {
        this.show(document.querySelector('.main-product-section .button--vto'));
      }

      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'PRODUCT-VTO') this.hide();
      });
    }

    hide() {
      super.hide();
      if (this.VirtualTryOnSdk.isYMKModuleLoaded) {
        YMK.close();
      }
    }

    show(opener) {
      this.sku = opener.dataset.sku;
      let qrCodeUrl = opener.dataset.qrCode;
      super.show(opener);
      
      // if (theme.config.mqlSmall && theme.config.isTouch) {
        this.openModalVTO();
      // } else {
      //   this.showModalQrCode(qrCodeUrl);
      // }
    }
    
    showModalQrCode(qrCodeUrl) {
      if (qrCodeUrl) {
        let qrCodeImage = document.createElement('img');
        qrCodeImage.setAttribute('src', qrCodeUrl);
        this.qrCodeContent.querySelector('.vto-qrcode').innerHTML = '';
        this.qrCodeContent.querySelector('.vto-qrcode').appendChild(qrCodeImage);
      }
      
      this.qrCodeContent.style.opacity = '1';
      this.vtoContent.style.opacity = '0';
    }

    openModalVTO() {
      this.vtoContent.style.opacity = '1';
      this.qrCodeContent.style.opacity = '0';
      this.openYMKModule();
    }

    openYMKModule() {
      this.VirtualTryOnSdk.createYMKDiv(this);
      if (this.VirtualTryOnSdk.isYMKModuleLoaded) {
        YMK.close();
        this.initEvents();
        YMK.openHandAR(true);
      } else {
        this.VirtualTryOnSdk.loadYMKModule(this, this.initEvents.bind(this));
      }
    }

    initEvents() {
      this.initSwatch();
      this.registerYMKEvents();
    }

    initSwatch() {
      if (!this.swatches.querySelectorAll('input').length > 0) return;
      this.swatches.querySelectorAll('input').forEach((input) => {
        if(input.value == this.sku) {
          input.checked = true;
          this.initAddToCart(input);
          this.swatches.querySelector('ul').insertAdjacentElement('afterbegin', input.closest('.vto-swatch__item'));
        }
        input.addEventListener('change', (evt) => {
          var el = evt.currentTarget;
          this.sku = el.value;
          this.initAddToCart(el);
          YMK.applyMakeupBySku(this.sku);
        })
      })
    }

    initAddToCart(el) {
      this.toggleAddButton(true, '');
      this.addToCart.dataset.variantId = el.dataset.variantId;
      setTimeout(() => {
        if (el.dataset.productAvailable == "true") {
          this.toggleAddButton(false, '');
        } else {
          this.toggleAddButton(true, window.variantStrings.soldOut);
        }
      }, 200)
      
    }

    toggleAddButton(disable = true, text) {
      if (!this.addToCart) return;

      if (disable) {
        this.addToCart.classList.add('disabled', true);
        if (text) this.addToCart.textContent = text;
      }
      else {
        this.addToCart.classList.remove('disabled');
        this.addToCart.textContent = this.addToCart.dataset.preOrder === 'true' ? window.variantStrings.preOrder : window.variantStrings.addToCart;
      }

    }

    registerYMKEvents() {
      YMK.addEventListener("loading", function (progress) {
        this.loader.querySelector('[role="progressbar"]').style = '--value: ' + progress;
      }.bind(this));

      YMK.addEventListener("loaded", function () {
        YMK.applyMakeupBySku(this.sku);
        this.swatches.style.opacity = '1';
        setTimeout(() => {
          this.loader.classList.add('hidden');
          this.querySelector('.YMK-module-container').style.opacity = '1';
        }, 1000);
        // console.log('loaded VTO in modal');
      }.bind(this));

      YMK.addEventListener("closed", function () {
        this.loader.classList.remove('hidden');
        this.swatches.style.opacity = '0';
        this.loader.querySelector('[role="progressbar"]').style = '--value: 0';
        // this.hide();
        // console.log('closed VTO in modal');
      }.bind(this));

      YMK.addEventListener("opened", function () {
        this.querySelector('.YMK-module-container').style.opacity = '0';
        // console.log('opened VTO in modal');
      }.bind(this));
    }
  });
}